export function MatchDayPage() {
    return <div>Match Day Detail</div>;
}
